"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AreaRenderable", {
  enumerable: true,
  get: function get() {
    return _LineRenderable.LineRenderable;
  }
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _LineRenderable = require("./LineRenderable");

var _propTypes = _interopRequireDefault(require("prop-types"));

var Area =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Area, _React$Component);

  function Area() {
    (0, _classCallCheck2.default)(this, Area);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Area).apply(this, arguments));
  }

  (0, _createClass2.default)(Area, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_LineRenderable.LineRenderable, (0, _extends2.default)({
        area: true
      }, this.props));
    }
  }]);
  return Area;
}(_react.default.Component);

exports.default = Area;
(0, _defineProperty2.default)(Area, "chartType", 'canvas');